<template>
    <v-flex v-if="$vuetify.breakpoint.mdAndUp" md4 text-right id="coupon-img">
        <img
            :src="getCouponImageUrl"
            class="img-coupon"
            alt="image-coupon" />
    </v-flex>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'coupon-print-button',
    computed: {
        ...mapGetters({
            getStaticFilesUrl: 'getStaticFilesUrl',
        }),
        getCouponImageUrl() {
            let host = this.getStaticFilesUrl;
            let logo = 'coupon.png';
            return `${host}/images/${logo}`;
        },
    },
};
</script>

<style lang="scss" scoped>
    #coupon-img {
        position: relative;
        left: 1px;
    }
    .img-coupon {
        width: 70%;
        border-bottom-left-radius: 35%;
    }
</style>
